import find from 'lodash/find';
import ResultsInfo from '@Services/ResultsInfo';
import SearchStorage from '@Services/SearchStorage';
import Breadcrumb from '@Services/Breadcrumb';
import RelativeContextService from '@Containers/RelativeContext/RelativeContextNgService';
import { stateParams as stateParamsSelector } from '@Selectors/StateParamsSelectors';
import setStateParamsAction from '@Actions/StateParamsActions';
import { onHeatmapButtonClick as onHeatmapButtonClickAction } from '@Pages/Heatmap/HeatmapSettingsDialog/actions';
import { trackHeatmapButtonClick } from '@Containers/PreviewResultsHeatmapButton/analytics';

// eslint-disable-next-line import/prefer-default-export
export const onHeatmapButtonClick =
  ({ searchId, context, hitSetKey, resultName, databaseId, feedbacks, groupId }) =>
  async (dispatch, getState) => {
    // Heatmap is heavily dependent on results stateParams, so the trick is to substitute them
    // Preserve original state params
    const originalStateParams = stateParamsSelector(getState()).toJS();

    try {
      // AA
      trackHeatmapButtonClick();

      // Submit to results (similar as on quick results)
      const feedbackWithStructure = find(feedbacks, 'structure');
      await SearchStorage.extendItem(searchId, { [context]: feedbackWithStructure });
      await ResultsInfo.commitResultsToBreadcrumbs(groupId);

      // Set new state params
      const newStateParams = { searchId, context, hitSetKey, resultName, databaseId };
      dispatch(setStateParamsAction(newStateParams));

      // Get related contexts
      const relativeContexts = await RelativeContextService.getRelativeContexts({
        context,
        hitSetKey,
        resultName,
        databaseId,
      });
      const { hitSetKey: fullHitSetKey } = relativeContexts.find((relativeContext) => !!relativeContext.hitSetKey) || {};

      // Update active breadcrumb with full hitSetKey
      Breadcrumb.updateBreadcrumbs({ context, resultName, databaseId, hitSetKey: fullHitSetKey });

      // Update state params with full hitSetKey
      dispatch(setStateParamsAction({ ...newStateParams, hitSetKey: fullHitSetKey }));

      // Open heatmap
      dispatch(onHeatmapButtonClickAction());
    } catch (e) {
      Logger.error(e);
      // Restore original state params in case of error
      dispatch(setStateParamsAction(originalStateParams));
    }
  };
